/**
 * BE permission flag strings consumed by `menu-catalog.js` — keep this shape
 * byte-stable. For the permission ACTION enum + flag mapping, use the new
 * Permission Access Layer instead.
 *
 * @deprecated For action constants, import `ACTION` from `shared/lib/permissions`.
 */
export const Permission = {
  CREATE: 'can_create',
  READ: 'can_read',
  UPDATE: 'can_update',
  DELETE: 'can_delete',
};
